import { IAuthUserCompanyOutlet } from "../../contexts/AuthProvider/AuthProvider";
import { ICompanyOutlet } from "../../redux/companyOutlet/companyOutlet.types";
import { initialCompanyOutlet } from "../../redux/companyOutlet/defaultState";

export const LOCAL_KEY_BILLING_INFO = "billing_info";

export const getBillingCompanyFromStorage = (): ICompanyOutlet => {
	const OutletInfo = localStorage.getItem(LOCAL_KEY_BILLING_INFO);
	return OutletInfo && OutletInfo !== 'undefined'
		? JSON.parse(OutletInfo)
		: (initialCompanyOutlet as ICompanyOutlet);
};

export const saveBillingCompanyInStorage = (
	customer_info: IAuthUserCompanyOutlet
) => {
	localStorage.setItem(LOCAL_KEY_BILLING_INFO, JSON.stringify(customer_info));
};
